const Employee = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-employee" */ '@/pages/base-info/order-properties/employee/index.vue'
  )
const CreateEmployee = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-employee" */ '@/pages/base-info/order-properties/employee/create.vue'
  )
const EditEmployee = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-employee" */ '@/pages/base-info/order-properties/employee/edit.vue'
  )

export default {
  path: 'employee',
  meta: {
    label: 'employee',
    auth: 'employee'
  },
  component: {
    name: 'Employee',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoPropertyEmployee',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Employee
    },
    {
      name: 'BaseInfoCreatePropertyEmployee',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateEmployee
    },
    {
      name: 'BaseInfoEditPropertyEmployee',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditEmployee,
      props: true
    }
  ]
}
